var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('create',{attrs:{"current-user":_vm.currentUser,"step":_vm.step},on:{"onStepChange":_vm.handleStep}})}
var staticRenderFns = []

export { render, staticRenderFns }